import React from 'react';
import { Link } from 'react-router-dom';
import { Users } from 'lucide-react';
import { Section } from './FormFields';

const TeamTab = () => {
  return (
    <Section title="Team Management" description="Add and manage team members that will appear on the 'Meet Our Team' page.">
      <div className="text-center py-8">
        <Users className="w-16 h-16 text-slate-300 mx-auto mb-4" />
        <p className="text-slate-600 mb-6">Manage your management team and teachers through the dedicated team management interface.</p>
        <Link
          to="/admin/team"
          data-testid="go-to-team-management"
          className="inline-flex items-center gap-2 bg-slate-900 text-white px-6 py-3 rounded-lg font-medium hover:bg-slate-800"
        >
          <Users className="w-5 h-5" />
          Open Team Management
        </Link>
      </div>
    </Section>
  );
};

export default TeamTab;
